module.exports = _.dropRight;